import { forwardRef, memo, useMemo } from "react"
import reactFastCompare from 'react-fast-compare'

import './grid.scss'

const Grid = (props, ref) => {
    let {
        className, style,
    } = props

    const {
        children, padding, margin, gap, columns, rows, autoColumns, autoRows,
        direction, itemsX, itemsY, contentX, contentY,
        centerContent, centerItems, w100, h100, maxWidth, maxHeight, selfY, selfX,
        skipClickOutside = false,
        ...rest
    } = props

    style = useMemo(() => ({
        display: '',
        padding,
        margin,
        gap: gap,
        gridTemplateColumns: columns,
        gridTemplateRows: rows,
        gridAutoColumns: autoColumns,
        gridAutoRows: autoRows,
        gridAutoFlow: direction,
        justifyItems: itemsX,
        alignItems: itemsY,
        justifyContent: contentX,
        justifySelf: selfX,
        alignContent: contentY,
        alignSelf: selfY,
        // placeContent: centerContent && 'center',
        // placeItems: centerItems && 'center',
        width: w100 && '100%',
        height: h100 && '100%',
        maxWidth,
        maxHeight,
        ...style
    }), [padding, margin, gap, columns, rows, autoColumns, autoRows,
        direction, //centerContent, centerItems,
        itemsX, itemsY, contentX, selfX, contentY, selfY, w100, h100, maxWidth, maxHeight, style])

    className = className ? `${className} grid` : 'grid'

    return (
        <div ref={ref} {...{ ...rest, style, className, "data-skip-click-outside": skipClickOutside ? 1 : 0 }}>
            {children}
        </div>
    )
}

export default memo(forwardRef(Grid), reactFastCompare)